module.exports = __webpack_public_path__ + "img/login-banner.5b1133ff.jpg";